import { render, staticRenderFns } from "./AchatCreditsTunnel.vue?vue&type=template&id=00fa6325&scoped=true&"
import script from "./AchatCreditsTunnel.vue?vue&type=script&lang=js&"
export * from "./AchatCreditsTunnel.vue?vue&type=script&lang=js&"
import style0 from "./AchatCreditsTunnel.vue?vue&type=style&index=0&id=00fa6325&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa6325",
  null
  
)

export default component.exports